import React, { useMemo } from 'react';
import PropTypes from 'prop-types';
import { getMaxCharsForWidth } from '../../utils/string-utils';

const MAX_WIDTH = 350;

const OrderDescription = ({ description }) => {
  if (!description) return null;
  const maxWidth = window.innerWidth < 600 ? window.innerWidth / 100 * 30 : MAX_WIDTH;
  const maxChars = useMemo(() => getMaxCharsForWidth(description, maxWidth), [description, maxWidth]);
  const { firstLine, secondLine } = useMemo(() => {
    if (description.length <= maxChars) {
      return { firstLine: description, secondLine: null };
    }

    let breakPoint = maxChars;
    while (breakPoint > 0 && description[breakPoint] !== ' ') {
      breakPoint--;
    }

    if (breakPoint === 0) breakPoint = maxChars;
    return {
      firstLine: description.substring(0, breakPoint).trim(),
      secondLine: description.substring(breakPoint).trim()
    };
  }, [description]);

  return secondLine ? (
    <div className="new-transaction_description__text" style={{ maxWidth: maxWidth }}>
      <div>{firstLine}</div>
      <div className="-text-ellipsis">{secondLine}</div>
    </div>
  ) : (
    <div className="new-transaction_description__text" style={{ maxWidth: maxWidth }}>{description}</div>
  );
};

OrderDescription.propTypes = {
  description: PropTypes.string.isRequired,
};

export default OrderDescription;